<script setup lang="ts">
  import { onMounted, ref } from 'vue'
  import { useRoute } from 'vue-router'
  import { authorizeRights } from '@services/RightsService'
  import { RIGHTS } from '@interfaces/RightsEnum'

  const route = useRoute()
  const tabs = ref([{ heading: 'Fiche utilisateur', route: 'record' }])

  onMounted(() => {
    if (authorizeRights([RIGHTS.VIEW_USERS])) {
      tabs.value.push({ heading: 'Autorisations', route: 'rights' })
    }
  })

  function classForTabs(currentRoute: string) {
    if (route.path.indexOf(currentRoute) != -1) {
      return 'nav-link active'
    }
    return 'nav-link'
  }
</script>
<template>
  <ul role="tablist" class="nav nav-tabs justify-content-start">
    <li v-for="(tab, index) in tabs" :key="index" class="nav-item">
      <RouterLink
        id="0"
        :class="classForTabs(tab.route)"
        href=""
        role="tab"
        :to="tab.route"
      >
        {{ tab.heading }}</RouterLink
      >
    </li>
  </ul>
  <RouterView />
</template>
<style scoped>
  .nav-link.active {
    background-color: #f5f5f5 !important;
  }
</style>
